

export default function Team() {
  const teamMembers = [
    {
      image: "/images/pprosvetov.jpg",
      name: "Павел Просветов",
      role: "Tech Lead & Full-Stack разработчик",
      experience: "10+ лет опыта в разработке масштабируемых веб-приложений",
      color: "hover:text-sprintwise-primary"
    },
    {
      image: "/images/team-maria.jpg",
      name: "Мария Сидорова",
      role: "Frontend Lead",
      experience: "6+ лет специализации на пользовательских интерфейсах",
      color: "hover:text-sprintwise-secondary"
    },
    {
      image: "/images/dkozlov.jpg",
      name: "Дмитрий Козлов",
      role: "Backend архитектор",
      experience: "10+ лет создания высоконагруженных систем",
      color: "hover:text-sprintwise-accent"
    },
    {
      image: "/images/team-anna.jpg",
      name: "Анна Волкова",
      role: "Mobile разработчик",
      experience: "5+ лет разработки iOS и Android приложений",
      color: "hover:text-green-500"
    }
  ];

  return (
    <section id="team" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-sprintwise-dark mb-6" data-testid="team-title">
            Наша <span className="gradient-text">команда</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-testid="team-description">
            Опытные специалисты с глубокой экспертизой в современных технологиях разработки
          </p>
        </div>
        
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 group" data-testid={`team-member-${index}`}>
              <img 
                src={member.image} 
                alt={member.name} 
                className="w-24 h-24 rounded-full mx-auto mb-4 group-hover:scale-105 transition-transform duration-300" 
                data-testid={`team-member-image-${index}`}
              />
              <h3 className="text-xl font-semibold text-sprintwise-dark mb-2" data-testid={`team-member-name-${index}`}>
                {member.name}
              </h3>
              <p className="text-gray-600 mb-3" data-testid={`team-member-role-${index}`}>
                {member.role}
              </p>
              <p className="text-sm text-gray-500 mb-4" data-testid={`team-member-experience-${index}`}>
                {member.experience}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
